import React, { Component } from "react";
import Select from "react-select";
import Creatable from 'react-select/creatable';

export default function SelectInput(props) {
  const isMulti = props.multi || props.isMulti

  const onChange = (event) => {
    if (props.input.onChange && event != null) {
      if (isMulti) {
        props.input.onChange(event.map(item => item.value))
      } else {
        props.input.onChange(event.value);
      }
    } else {
      props.input.onChange(null);
    }
    if (props.onOptionChange) {
      props.onOptionChange(event.value);
    }
  }

  let selectedValue = props.selectedValue
  if (isMulti) {
    if (!_.has(selectedValue[0], 'value')) {
      // Not already an object
      selectedValue = props.options?.filter(el => props.selectedValue.some((value) => value === el.value)) || []
    }
  } else {
    if (!_.has(selectedValue, 'value')) {
      // Not already an object
      selectedValue = props.options?.find(el => el.value === props.selectedValue) || ""
    }
  }

  return (
    <div className="relative">
      <div className="input">
        {!props.creatable ?
          <Select {...props}
            inputId={props.input.name}
            isMulti={isMulti}
            value={selectedValue}
            onChange={onChange}
            options={props.options}
            classNamePrefix="Select"
            classNames={{
              control: (state) =>
                state.isFocused ? 'tw-border-red-600 tw-p-1' : 'tw-p-1',
            }}
          /> :
          <Creatable {...props}
            inputId={props.input.name}
            isMulti={isMulti}
            value={selectedValue}
            onChange={onChange}
            options={props.options}
            classNamePrefix="Select"
            classNames={{
              control: (state) =>
                state.isFocused ? 'tw-border-red-600 tw-p-1' : 'tw-p-1',
            }}
          />}
      </div>
      <div>
        {props.meta.touched && ((props.meta.error && <span className="error_txt">{props.meta.error}</span>) || (props.meta.warning && <span className="error_txt">{props.meta.warning}</span>))}
      </div>
      {props.validationError && <div>
        {(props.validationError && <span className="error_txt">{props.validationError}</span>)}
      </div>}
    </div>
  );
}
